import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import Articles from './components/Articles';
import './styles/index.css';

// Define routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />
  },
  {
    path: "/articles",
    element: <Articles />
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
); 